import {ref} from "vue"
import store from '@/store'
import {toastController} from '@ionic/vue';

const data = ref<any>(null)

export default function MeetingsService () {

    async function openToastOptions(message, color = 'success') {
        const toast = await toastController.create({
            color: color,
            duration: 2000,
            message: message,
        });
        await toast.present();
    }

    const joinMeeting = lessonId => {
        const classId = JSON.parse(localStorage.getItem('currentClass') || '{}').id
        return store
            .dispatch('meetings/joinMeeting', {
                "class_id": classId,
                "meeting_id": lessonId,
            })
            .catch(error => {
                console.log(error.response)
                if (!error.response || error.response.status !== 422) {
                    openToastOptions('Impossibile caricare i meeting', 'danger')
                }
            })
    }

    const getCurrentMeetings = () => store.getters['meetings/getListMeetings']

    return {
        data,
        getCurrentMeetings,
        joinMeeting,
    }
}